export const utmKeys = [
  "utm_campaign",
  "utm_source",
  "utm_medium",
  "aff_sub",
  "click_id",
  "partner_id",
];
